export default "__VITE_ASSET__BTBMpliX__"